import { createSlice } from '@reduxjs/toolkit';
import EntityState from '@/data/EntityState';
import { fetchPunches } from '@/data/punch/actions';
import Punch from '@/data/punch/model';
import generateThunkReducers from '@/data/util/generateThunkReducers';
import { mergeEntityItems } from '@/data/util/sliceHelpers';
import { camelCaseToSnakeCaseObject } from '@/shared/util/objectCaseUtilities';

const initialState = new EntityState<Punch>();

export const punchSlice = createSlice({
  name: 'punch',
  initialState,
  reducers: {
    receivePunches: (state, action) => {
      return mergeEntityItems(
        state,
        (action.payload as Punch[])?.map(punch => camelCaseToSnakeCaseObject(punch)),
        Punch,
      );
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchPunches.fulfilled, (state, action) => {
      return mergeEntityItems(
        state,
        action.payload.data.map(punch => camelCaseToSnakeCaseObject(punch)),
        Punch,
      );
    });
    generateThunkReducers(builder, 'punch');
  },
});

export const { receivePunches } = punchSlice.actions;

export default punchSlice.reducer;
